var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"text-xl",class:_vm.fontClass},[_vm._v(_vm._s(_vm.personalizationText))]),(_vm.hasHelperText)?_c('p',{staticClass:"italic mt-3",domProps:{"innerHTML":_vm._s(_vm.bp('personalizeMessage'))}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }